import type { ThemeV1 } from "./schema";

export const themeAssetRegistry = Object.freeze({
  "monkeytilt-mark": "/app/static/themes/monkeytilt/logo-head.webp",
  "monkeytilt-wordmark": "/app/static/themes/monkeytilt/logo-wordmark.webp",
  "tilt-racing-logo": "/app/static/themes/monkeytilt/tilt-racing-logo.png",
  "monkeytilt-sidebar": "/app/static/themes/monkeytilt/sidebar-background.avif",
  "monkeytilt-favicon": "/app/static/themes/monkeytilt/favicon.png",
});

export function resolveThemeAsset(
  key:
    | ThemeV1["brand"]["markAssetKey"]
    | ThemeV1["brand"]["wordmarkAssetKey"]
    | ThemeV1["assets"]["sidebarBackgroundKey"]
    | ThemeV1["assets"]["faviconKey"],
) {
  return key ? themeAssetRegistry[key] : null;
}
